import { internal } from "@/public/utils/env";
import { Vue } from "@/public/utils/customVue";

let $edApi = Vue.prototype.$edApi;

export default {
    state: {
        revisionsList: [],
        selectId: 0,
        revisionfileKey: "",
        VersionTipType: "",
    },
    mutations: {
        setVersionState(state, obj) {
            state[obj.type] = obj.data;
        },
        delVersion(state, obj) {
            let index = 0;
            if (this._vm.isPrivate) {
                index = state.revisionsList.findIndex((item) => item.ver_file_key == state.revisionfileKey);
            } else {
                index = state.revisionsList.findIndex((item) => item.id == state.selectId);
            }
            state.revisionsList.splice(index, 1);
        },
    },
    actions: {
        getVersionList({ rootGetters, commit }, obj) {
            let param = Object.assign({ obj: obj.obj, file_key: rootGetters.fileKey }, rootGetters.apiParam);
            return new Promise((resolve, reject) => {
                $edApi
                    .getVersionList(param)
                    .then((res) => {
                        const manual = res.filter((item) => item.auto == 0);
                        manual.forEach((item, index) => {
                            if (!item.name) item.name = `${internal ? "手动保存" : "Manual Save"}-${manual.length - index}`;
                        });
                        commit("setVersionState", { type: "revisionsList", data: res });
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delVersion({ rootGetters, commit, state }, obj) {
            let param = Object.assign({ version_id: state.selectId }, rootGetters.apiParam);
            if (this._vm.isPrivate) {
                let temp = null;
                for (let i = 0; i < state.revisionsList.length; i++) {
                    if (state.revisionsList[i].ver_file_key == state.revisionfileKey) {
                        temp = state.revisionsList[i];
                        break;
                    }
                }
                Object.assign(param, {
                    file_key: temp.file_key,
                    ver_file_key: temp.ver_file_key,
                });
            }
            return new Promise((resolve, reject) => {
                $edApi
                    .delVersion(param)
                    .then((res) => {
                        commit("delVersion");
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        backVersion({ rootGetters, commit, state }, obj) {
            if (window.EDCONFIG.IS_SDK) {
                return new Promise((resolve, reject) => {
                    this._vm.sdkApp
                        .promisePostMessage("GET_VERSION_BACK", { version_id: state.selectId })
                        .then((res) => {
                            this.dispatch("getVersionList", { obj: obj.name });
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }

            let param = Object.assign({ version_id: state.selectId }, rootGetters.apiParam);
            if (this._vm.isPrivate) {
                let temp = null;
                for (let i = 0; i < state.revisionsList.length; i++) {
                    if (state.revisionsList[i].ver_file_key == state.revisionfileKey) {
                        temp = state.revisionsList[i];
                        break;
                    }
                }
                Object.assign(param, {
                    file_key: temp.file_key,
                    ver_file_key: temp.ver_file_key,
                });
            }
            return new Promise((resolve, reject) => {
                $edApi
                    .backVersion(param)
                    .then((res) => {
                        let ossParam = { url: obj.obj, sign: res.data.sign || res.data.query, exp: res.data.exp, responseType: "blob" };
                        $edApi
                            .downloadOSSFile(ossParam)
                            .then((res) => {
                                resolve(res);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
